/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { makeStyles } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles(theme => ({
  item: {
    margin: '1.5rem',
  },
  value: {
    fontWeight: theme.typography.fontWeightBold,
  },
}));

export default function DetailsItem(props) {
  const classes = useStyles();
  const { name, value } = props;

  return (
    <div className={classes.item}>
      <div>{name}</div>
      <div className={classes.value}>{value || '-'}</div>
    </div>
  );
}
